module.exports = __webpack_public_path__ + "static/img/wfs.8f505fe1.svg";